module.exports = __webpack_public_path__ + "img/shop_default.fc20dd8a.svg";